import React from 'react';
import TopBar from './components/TopBar';
import Landing from './components/Landing';
import AboutMe from './components/AboutMe';
import Skills from './components/Skills';
import Education from './components/Education';
import Projects from './components/Projects';
import Misc from './components/Misc';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Noise Overlay */}
      <div className="noise-overlay"></div>

      <TopBar />
      <Landing />
      <AboutMe />
      <Skills />
      <Education />
      <Projects />
      <Misc />
      <Footer />
    </div>
  );
}

export default App;